import { useContext } from "react";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box } from "@mui/material";
import { SortArrow } from "../../../Features/NewInvoiceBook/InvoiceBookPages/InvoiceList";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const CashBookListTableHeader = ({ isAscending = false, handleSort, disabled = false }) => {
  const [I18n] = useContext(LanguageContext);

  return (
    <Box id="cash_book_table_header" className="invoiceListTableHeader">
      <Box
        id="cash_book_date_sort_header"
        onClick={disabled ? undefined : () => {
          triggerLogEvent(analytics, "cash_book_sort", { sort_field: "date", is_ascending: !isAscending });
          handleSort();
        }}
        className={`invListTableHeaderCol eightColumn textLeft sidebarOption ${disabled ? "" : "cursorPointer"}`}
      >
        <ParagraphText id="cash_book_header_date_label" className="fontSize12 fontWeight500 newLightColor">
          {I18n.date}
          <SortArrow id="cash_book_date_sort" isAscending={!isAscending} disabled={disabled} />
        </ParagraphText>
      </Box>
      <Box id="cash_book_header_contact_col" className="invListTableHeaderCol eightColumn textLeft">
        <ParagraphText id="cash_book_header_contact_label" className="fontSize12 fontWeight500 newLightColor">{I18n.contact}</ParagraphText>
      </Box>
      <Box id="cash_book_header_document_no_col" className="invListTableHeaderCol eightColumn textLeft">
        <ParagraphText id="cash_book_header_document_no_label" className="fontSize12 fontWeight500 newLightColor">{I18n.document_no}</ParagraphText>
      </Box>
      <Box id="cash_book_header_type_col" className="invListTableHeaderCol eightColumn textLeft">
        <ParagraphText id="cash_book_header_type_label" className="fontSize12 fontWeight500 newLightColor">{I18n.type}</ParagraphText>
      </Box>
      <Box id="cash_book_header_category_col" className="invListTableHeaderCol eightColumn textLeft">
        <ParagraphText id="cash_book_header_category_label" className="fontSize12 fontWeight500 newLightColor">{I18n.category}</ParagraphText>
      </Box>
      <Box id="cash_book_header_amount_col" className="invListTableHeaderCol eightColumn textRight">
        <ParagraphText id="cash_book_header_amount_label" className="fontSize12 fontWeight500 newLightColor">{I18n.amount}</ParagraphText>
      </Box>
      <Box id="cash_book_header_balance_col" className="invListTableHeaderCol eightColumn textRight">
        <ParagraphText id="cash_book_header_balance_label" className="fontSize12 fontWeight500 newLightColor">{I18n.balance}</ParagraphText>
      </Box>
      <Box id="cash_book_header_actions_col" className="invListTableHeaderCol eightColumn textCenter">
        <ParagraphText id="cash_book_header_actions_label" className="fontSize12 fontWeight500 newLightColor">{I18n.actions}</ParagraphText>
      </Box>
    </Box>
  );
};

export default CashBookListTableHeader;
